angular.module('pitch.media', [
    'pitch.app',
    'satv.media',
    'satv.track'  
])

.run(function($rootScope, AuditionHandler, DownloadHandler) {
    $rootScope.$on('MEDIA_PLAY', AuditionHandler);
    $rootScope.$on('MEDIA_DOWNLOAD', DownloadHandler);
})

;



// WEBPACK FOOTER //
// ./src/MediaClientBundle/Resources/js/angular/app.js